import { stripHTMLTags } from "@/src/utils/strip-html-tags";

export type OverviewEntry = { key?: string | null; value?: string | null };

type WithOverview = { overview_information?: unknown } | null | undefined;

export const overviewEntries = (meta: WithOverview): OverviewEntry[] => {
  const raw = meta?.overview_information;

  if (!Array.isArray(raw)) return [];

  return (raw as OverviewEntry[]).filter(
    (entry) =>
      !!entry && typeof entry.value === "string" && entry.value.trim() !== "",
  );
};

export const overviewText = (meta: WithOverview): string =>
  overviewEntries(meta)
    .map((entry) => `${entry.key ?? ""} ${stripHTMLTags(entry.value ?? "")}`)
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();
